import { render, staticRenderFns } from "./profilo.html?vue&type=template&id=3fd1aa42&external"
import script from "./Profilo.vue?vue&type=script&lang=js"
export * from "./Profilo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports